import { TextareaGroup } from "../../styles/FormGroup";

type TextareaInputProps = {
    name: string;
    label?: string;
    onChange: (name: string, value: string) => void;
    onBlur?: (name: string, value: string) => void;
    value?: string;
    error?: string;
    required?: boolean;
    description?: string;
    [key: string]: any;
};

const TextareaInput = ({
    name,
    label,
    onChange,
    onBlur = null,
    required = false,
    value = "",
    error = "",
    description = "",
    ...props
}: TextareaInputProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        onChange(name, value);
    };

    const handleBlur = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (!onBlur) {
            return;
        }

        const { name, value } = e.target;
        onBlur(name, value);
    };

    return (
        <TextareaGroup className="form-group">
            {label ? (
                <label htmlFor={name}>
                    {label}
                    {required ? " *" : ""}
                </label>
            ) : (
                ""
            )}
            <textarea
                {...props}
                name={name}
                id={name}
                className="form-control"
                onChange={handleChange}
                onBlur={handleBlur}
                value={value}
            />
            <div>{description ? <small>{description}</small> : ""}</div>
            <div>{error && !value.length ? <span className="error">{error}</span> : ""}</div>
        </TextareaGroup>
    );
};

export default TextareaInput;
